export default "__VITE_ASSET__C3idoE19__"